<template>
  <div>
    <label class="block text-sm leading-5 font-medium text-gray-700"
      >{{ label }}<span v-if="required"> *</span></label
    >
    <el-select-v2
      class="input-select-with-search mt-1"
      :class="{ error: error }"
      v-model="selected"
      :options="mappedOptions"
      filterable
      clearable
      :placeholder="placeholder"
      no-match-text="Keine Ergebnisse gefunden"
      no-data-text="Keine Optionen verfügbar"
      @change="onSelectChange"
    />
    <!-- hidden input -->
    <input type="hidden" :name="name" :id="id" :value="selectedOptionValue" />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { ElSelectV2 } from 'element-plus';
import 'element-plus/es/components/select-v2/style/css';

const props = defineProps({
  modelValue: [String, Number],
  options: Array,
  label: String,
  placeholder: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  error: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const selected = ref(null);

const mappedOptions = computed(() => {
  if (!props.options) {
    return [];
  }
  return props.options.map((option) => ({
    label: option.name,
    value: option.value,
  }));
});

const selectedOptionValue = computed(() => {
  return selected.value ?? '';
});

const onSelectChange = (val) => {
  emit('update:modelValue', val);
};

const findSelectedValue = (val) => {
  if (val === null || val === "" || val === 0) {
    return null;
  }
  const found = props.options.find(
    (option) => Number(option.value) === Number(val)
  );
  return found ? found.value : null;
};

// Update selected when modelValue or options change
watch([() => props.modelValue, () => props.options], () => {
  selected.value = findSelectedValue(props.modelValue);
}, { immediate: true, deep: true });
</script>
